import { useEffect, useState } from 'react';

/**
 * The natural size of the picture at `url`, once it has loaded; null before, on a failure, or with
 * no url. The camera panel's calibration status needs it: a calibration fitted on a picture of a
 * different size is out of date (`observer-autogen-plan-projection`, R11). The browser has the
 * picture already (the panel shows it), so this costs no second read.
 */
export function useImageNaturalSize(
  url: string | undefined,
): { width: number; height: number } | null {
  const [size, setSize] = useState<{ url: string; width: number; height: number } | null>(null);
  useEffect(() => {
    if (!url || typeof Image === 'undefined') return;
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (!cancelled && img.naturalWidth > 0 && img.naturalHeight > 0) {
        setSize({ url, width: img.naturalWidth, height: img.naturalHeight });
      }
    };
    img.src = url;
    return () => {
      cancelled = true;
      img.onload = null;
    };
  }, [url]);
  return size && size.url === url ? { width: size.width, height: size.height } : null;
}
